import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// materialize-css
import 'materialize-css/dist/css/materialize.min.css';
//import 'material-design-icons/iconfont/material-icons.css';

// materialize-css
//import 'materialize-css'
//import * as M from 'materialize-css';
//const M = require('materialize-css');
//import * as M from 'materialize-css';

// jquery
//import * as jQuery from 'jquery';
//const jQuery = require('jquery');

createApp(App).use(store).use(router).mount('#app');
//createApp(App).use(store).use(router).use(M).use(jQuery).mount('#app');
// const app = createApp(App).use(store).use(router).mount('#app');
